// Per-device language for the patient welcome / post-op display. Chosen on-screen
// via the doctor control panel and persisted to localStorage so it survives
// reloads on that display. Kept independent of the app's vue-i18n locale so
// switching the kiosk language never changes the doctor app's language.

const STORAGE_KEY = "dc.welcomeLang";

export const SUPPORTED_LANGS = ["th", "en"];
export const DEFAULT_LANG = "th";

// Coerce any stored/incoming value to a supported language code, falling back to
// the default for anything missing or unrecognized.
export function normalizeLang(raw) {
  return SUPPORTED_LANGS.includes(raw) ? raw : DEFAULT_LANG;
}

export function loadLang() {
  try {
    return normalizeLang(localStorage.getItem(STORAGE_KEY));
  } catch (e) {
    return DEFAULT_LANG;
  }
}

export function saveLang(lang) {
  try {
    localStorage.setItem(STORAGE_KEY, normalizeLang(lang));
  } catch (e) {
    /* ignore quota/availability errors */
  }
}
